import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'groupFilterCertList'
})
export class GroupFilterCertListPipe implements PipeTransform {

  checkEmpty(item) {
    if (item.toString().trim() === '') {
      return true;
    }
    return false;
  }

  transform(value, args: any) {

    let hrStatus = args.split(',');
    if (this.checkEmpty(hrStatus)) {
      return value;
    }

    return value.filter((item) => {
      return this.ifExist(hrStatus, item.statushradmin_desc) !== -1;
    });
  }

  ifExist(args, item) {
    for (let i = 0; i < args.length; i++) {
      args[i] = args[i].trim();
    }
    if (item === null) {
      if (item.trim() === '') {
        return -1;
      }
    }
    if (this.checkEmpty(args)) {
      return 0;
    }
    return args.indexOf(item.trim());
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/group-filter-cert-list.pipe.ts